import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import errorValue from '../translations/errors.json';

const ERRORS = {
  GLOBAL: {
    GENERAL: 'G_200',
  },
  LOGIN: {
    GENERIC: 'G_200',
    401: 'D_107',
    400: 'D_505',
    500: 'D_505',
  },
  OTP: {
    401: 'D_615',
    TextOutputCallback: 'E_116',
    ChoiceCallback: 'E_116',
  },
  SIGNUP: {
    GENERAL: 'G_200',
    userNameVALID_USERNAME: 'D_504',
    userNameMATCH_REGEXP: 'D_506',
    password: 'D_611',
    breachedpassword: 'D_613',
    SPECIAL_COMBINATION: 'D_620',
    mailBLOCKED_EMAIL_DOMAIN: 'D_508',
  },
  LOGOUT: {
    401: 'G_200',
  },
};

export const SERVICES = {
  LOGIN: 'LOGIN',
  OTP: 'OTP',
  SIGNUP: 'SIGNUP',
  LOGOUT: 'LOGOUT',
};

export const mapErrorCode = (service, err) => {
  if (err) {
    let errorCode;
    const serviceErrorCode = get(err.payload, 'code');
    errorCode = get(ERRORS, `${service}.${serviceErrorCode}`);

    if (serviceErrorCode) {
      errorCode = get(ERRORS, `${service}.${serviceErrorCode}`);
    }

    if (!errorCode) {
      if (get(ERRORS, `${service}.GENERIC`)) {
        return ERRORS[service].GENERIC;
      }
      return ERRORS.GLOBAL.GENERAL;
    }
    return errorCode;
  }
  if (get(ERRORS, `${service}.GENERIC`)) {
    return ERRORS[service].GENERIC;
  }
  return ERRORS.GLOBAL.GENERAL;
};

export const mapOtpErrorCode = (service, err) => {
  if (err) {
    let errorCode;
    const serviceErrorCode = get(err.payload.callbacks[0], 'type');
    errorCode = get(ERRORS, `${service}.${serviceErrorCode}`);

    if (serviceErrorCode) {
      errorCode = get(ERRORS, `${service}.${serviceErrorCode}`);
    }

    if (!errorCode) {
      if (get(ERRORS, `${service}.GENERIC`)) {
        return ERRORS[service].GENERIC;
      }
      return ERRORS.GLOBAL.GENERAL;
    }
    return errorCode;
  }
  if (get(ERRORS, `${service}.GENERIC`)) {
    return ERRORS[service].GENERIC;
  }
  return ERRORS.GLOBAL.GENERAL;
};

const pwnedPasswordErrorMsg =
  'Constraint Violation: The password value for attribute userPassword was found to be unacceptable: The provided password contained a word from the server&#39;s dictionary';

export const mapSignupErrorCode = (service, err) => {
  try {
    if (!err) {
      return get(ERRORS, `${service}.GENERIC`) || ERRORS.GLOBAL.GENERAL;
    }

    let serviceErrorCode = get(err.error, 'code');
    const detail = err?.error?.detail;
    const message = err?.error?.message;

    if (serviceErrorCode === 403 && !isEmpty(detail)) {
      const failedPolicy = detail.failedPolicyRequirements?.[0];
      const property = failedPolicy?.property;
      const failedPolicyRequirements = failedPolicy?.policyRequirements?.[0];
      if (property === 'userName' || property === 'mail') {
        serviceErrorCode = `${property}${failedPolicyRequirements?.policyRequirement}`;
      } else if (property === 'password' && failedPolicyRequirements?.regexp === '^((?!') {
        return get(ERRORS, `${service}.SPECIAL_COMBINATION`);
      } else {
        serviceErrorCode = property;
      }
    }
    if (serviceErrorCode === 403 && isEmpty(detail) && message?.includes('Cannot use breached password')) {
      return get(ERRORS, `${service}.breachedpassword`);
    }
    if (serviceErrorCode === 400 && message === pwnedPasswordErrorMsg) {
      return get(ERRORS, `${service}.password`);
    }
    const errorCode =
      get(ERRORS, `${service}.${serviceErrorCode}`) || get(ERRORS, `${service}.GENERIC`) || ERRORS.GLOBAL.GENERAL;

    return errorCode;
  } catch {
    return ERRORS.GLOBAL.GENERAL;
  }
};

export const mapLogoutErrorCode = (service, err) => {
  if (err) {
    const serviceErrorCode = get(err.data, 'code');
    const errorCode = get(ERRORS, `${service}.${serviceErrorCode}`);
    if (!errorCode) {
      return ERRORS.GLOBAL.GENERAL;
    }
    return errorCode;
  }
  return ERRORS.GLOBAL.GENERAL;
};

// Function to return error detail for a specific error code from json
// Can be used in the cases to handle error during user flow journeys specific to self service ui
export const mapErrorFromJson = (errCode) =>
  errCode && errorValue[errCode] ? { ...errorValue[errCode], errorCode: errCode } : null;
